// Shopify policy bodies sometimes repeat the page title supplied by the layout.
(() => {
  const policy = document.querySelector('.shopify-policy__container');
  const title = policy?.querySelector('.shopify-policy__title h1');
  const first = policy?.querySelector('.shopify-policy__body .rte')?.firstElementChild;
  const normalize = text => text.trim().replace(/\s+/g, ' ').toLocaleLowerCase();
  if (title && first?.tagName === 'H1' && normalize(title.textContent) === normalize(first.textContent)) first.hidden = true;
})();
